'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpcomingNavItem = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UpcomingNavItem = exports.UpcomingNavItem = function UpcomingNavItem(_ref) {
  var count = _ref.count;
  return _react2.default.createElement(
    'li',
    null,
    _react2.default.createElement(
      _reactRouter.Link,
      { to: '/profile/upcoming' },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'header.link.upcoming',
        defaultMessage: 'Upcoming'
      }),
      count > 0 && _react2.default.createElement(
        'span',
        { className: 'header__badge' },
        count
      )
    )
  );
};

UpcomingNavItem.propTypes = {
  count: _propTypes2.default.number
};